import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/img-empty.svg'


const _hoisted_1 = { class: "container-hjp-confirm-modal" }
const _hoisted_2 = { class: "header flex" }
const _hoisted_3 = { class: "content mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-extrabold mb-4" }, "Approve Kupon", -1)
const _hoisted_5 = { class: "md:grid grid-cols-2 gap-3" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Kategori:", -1)
const _hoisted_8 = { class: "text-base font-semibold" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Nopol:", -1)
const _hoisted_11 = { class: "text-base font-semibold" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Nama Kru:", -1)
const _hoisted_14 = { class: "text-base font-semibold" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Liter:", -1)
const _hoisted_17 = { class: "text-base font-semibold" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Tanggal Berlaku:", -1)
const _hoisted_20 = { class: "text-base font-semibold" }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Tanggal Isi:", -1)
const _hoisted_23 = { class: "text-base font-semibold" }
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Nama Pom:", -1)
const _hoisted_26 = { class: "text-base font-semibold" }
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Keterangan:", -1)
const _hoisted_29 = { class: "text-base font-semibold" }
const _hoisted_30 = { class: "border-left-grey-3 pl-4" }
const _hoisted_31 = { class: "lg:grid grid-cols-3 gap-1 mb-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold" }, "Foto Nopol: ", -1)
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  src: _imports_0,
  alt: "x"
}
const _hoisted_36 = { class: "flex items-center justify-end mt-6" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Approve")

import Dialog from 'primevue/dialog'
import QrScanner from '@/views/shared-components/QrScanner.vue'
import { PropType, computed, ref, onMounted } from 'vue'
import Button from 'primevue/button'
import numberFormat from '@/utils/helpers/numberFormat'
import moment from 'moment'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataAfterScanDialog',
  props: {
  isShowDialog: {
    type: Boolean,
    default: false
  },
  data: {
    default: null as any
  }
},
  emits: ["hideDialog", "onAfterApproved"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'onAfterApproved', data: any): void

}), expose: any, slots: any, attrs: any }) {

const props = __props



const fuelTransactionendpoint = '/transaction/v2/FuelingTransactions'
const showDialog = ref(props.isShowDialog)
const dataHeader = ref(props.data)
const dataSource = ref(null) as any

const onSubmit = () => {
  // console.log('data', data)
  emit('onAfterApproved', null)
  // eslint-disable-next-line no-use-before-define
  hideDialog()
}

const hideDialog = () => {
  // dialogDetailResi.value = false
  showDialog.value = false
  emit('hideDialog')
}

const getTransactionData = async () => {
  await apiUseCase.get(`${fuelTransactionendpoint}/${dataHeader.value?.FuelingTransaction?.Id}`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSource.value = result
    }
  })
}

onMounted(() => {
  getTransactionData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Dialog), {
      showHeader: false,
      visible: showDialog.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '60vw' },
      modal: true,
      contentClass: "wrap-content-hjp-confirm-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "pi pi-times cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideDialog()))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(dataHeader.value.CategoryDisplayName), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(dataHeader.value.VehicleRegNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(dataHeader.value.CrewName), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(numberFormat)(_unref(dataSource)?.Liters ?? 0)) + " - " + _toDisplayString(_unref(dataSource)?.FuelType), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(`${_unref(moment)(_unref(dataSource)?.FuelingTransactionVoucher?.StartDate).format('DD/MM/YYYY')} - ${_unref(moment)(_unref(dataSource)?.FuelingTransactionVoucher?.EndDate).format('DD/MM/YYYY')}`), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(moment)(dataHeader.value.ClaimedAt).format('DD/MM/YYYY')), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(dataSource)?.FuelStationPartnerName), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource)?.Notes, (note) => {
                  return (_openBlock(), _createElementBlock("div", { key: note }, [
                    _createElementVNode("p", _hoisted_29, _toDisplayString(note), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  (_unref(dataSource)?.VehicleImageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(dataSource)?.VehicleImageUrl,
                        alt: "foto-nopol",
                        style: {"height":"500px"}
                      }, null, 8, _hoisted_34))
                    : (_openBlock(), _createElementBlock("img", _hoisted_35))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_unref(Button), {
              class: "btn-back mr-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (hideDialog()))
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onSubmit()))
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})